// import { API } from '../../../../common/api/constants';

const formatName = user => {
  let value = 'Не указано';

  if (user.lastname && user.name && user.patronymic) {
    const lastName =
      user.lastname.charAt(0).toUpperCase() + user.lastname.slice(1);
    const abbr = `${user.name.charAt(0).toUpperCase()}.${user.patronymic
      .charAt(0)
      .toUpperCase()}`;

    value = `${lastName} ${abbr}`;
  }

  return value;
};

export const adjustCustomersData = customer => {
  const { ordersCount } = customer;
  const companyId = customer.company_id;
  const profileId = customer.profile_id;
  return {
    id: companyId,
    profileId: profileId,
    // status: customer && customer.profileStatusId,
    customer: {
      name: customer && customer.name ? customer.name : null,
      lastname: customer && customer.lastname ? customer.lastname : null,
      patronymic: customer && customer.patronymic ? customer.patronymic : null,
      nameLegal: customer.name_legal,
      photo: customer.picture,
      inn: customer.inn,
      subject: customer.subject,
      subjectKey: customer.subject && customer.subject.subject_key
    },
    responsible: {
      name:
        companyId &&
        companyId.representatives &&
        companyId.representatives.length > 0
          ? formatName(companyId.representatives[0])
          : 'Не указано',
      position:
        companyId &&
        companyId.representatives &&
        companyId.representatives.length > 0 &&
        companyId.representatives[0].positionId
          ? companyId.representatives[0].positionId.position
          : '',
    },
    balance: {
      value: 0,
      debt: 0,
    },
    data: {
      changed: customer.updated_at,
      created: customer.created_at,
    },
    orders: {
      completed: ordersCount && ordersCount.executed,
      readyToRun: ordersCount && ordersCount.ready,
    },
  };
};
